import { selectHoveredRequiredFieldKey } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { selectFocusedRequiredFieldKey } from '../../redux/features/selectors/uiSelectors.ts';
import { setFocusedRequiredFieldKey } from '../../redux/features/uiSlice.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';

export const isRequiredFieldAlertHighlighted = (
  fieldName: string,
  focusedRequiredFieldKey?: string,
  hoveredRequiredFieldKey?: string | null,
) => focusedRequiredFieldKey === fieldName || hoveredRequiredFieldKey === fieldName;

export const useRequiredFieldAlertHighlight = (fieldName: string) => {
  const dispatch = useAppDispatch();
  const focusedRequiredFieldKey = useAppSelector(selectFocusedRequiredFieldKey);
  const hoveredRequiredFieldKey = useAppSelector(selectHoveredRequiredFieldKey);
  const isAlertTarget = focusedRequiredFieldKey === fieldName;
  const isAlertHoverTarget = !isAlertTarget && hoveredRequiredFieldKey === fieldName;
  const isAlertHighlighted = isAlertTarget || isAlertHoverTarget;

  const clearAlertTarget = () => {
    if (isAlertTarget) {
      dispatch(setFocusedRequiredFieldKey(undefined));
    }
  };

  return { isAlertTarget, isAlertHighlighted, clearAlertTarget };
};
